import { render, staticRenderFns } from "./ManageForm.vue?vue&type=template&id=16df8775&scoped=true&"
import script from "./ManageForm.vue?vue&type=script&lang=ts&"
export * from "./ManageForm.vue?vue&type=script&lang=ts&"
import style0 from "./ManageForm.vue?vue&type=style&index=0&id=16df8775&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16df8775",
  null
  
)

export default component.exports